"use client";

import { PageTitle, SendOtpForm, VerifyOtpForm } from "@repo/components";
import { useAuth } from "@repo/lib/hooks/account";
import { useTranslations } from "next-intl";
const OtpWrapper = ({
  showVerifyOTP,
  setShowVerifyOTP,
  variant,
  handleCheckoutSignIn
}) => {
  const tLogin = useTranslations("LoginPage");
  const tCommon = useTranslations("Common");
  const {
    handleSubmit,
    handleValidation,
    formErrors,
    isPending,
    otpValue,
    setOtpValue,
    formValues,
    setFormErrors
  } = useAuth({
    mode: "otp",
    variant,
    handleCheckoutSignIn
  });
  return <>
      {!showVerifyOTP && <>
          <div className="mb-6 text-center">
            <PageTitle title={tLogin("Login_To_Your_Account")} variant="small" />
          </div>
          <SendOtpForm formValues={formValues} formErrors={formErrors} setFormErrors={setFormErrors} handleValidation={handleValidation} setShowVerifyOTP={setShowVerifyOTP} title={tLogin("Login_To_Your_Account")} />
        </>}
      {showVerifyOTP && <>
          <div className="mb-6 space-y-2 text-center">
            <PageTitle title={tCommon("Verification")} variant="small" />
            <p>{tLogin("Otp_Has_Been_Sent")}</p>
          </div>
          <VerifyOtpForm handleSubmit={handleSubmit} otpValue={otpValue} setOtpValue={setOtpValue} isPending={isPending} formValues={formValues} />
        </>}
    </>;
};
export default OtpWrapper;